/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Integration type
*/
export enum IntegType {
  INTEGRATION_TYPE_UNSPECIFIED = 'UNSPECIFIED',
  INTEGRATION_TYPE_REDSHIFT = 'REDSHIFT',
  INTEGRATION_TYPE_BIGQUERY = 'BIGQUERY',
  INTEGRATION_TYPE_SNOWFLAKE = 'SNOWFLAKE',
  INTEGRATION_TYPE_DATABRICKS = 'DATABRICKS',
  INTEGRATION_TYPE_MICROSOFT_FABRIC = 'MICROSOFT_FABRIC'
}
